import React from 'react';
import { Header, SpaceBetween, Tiles, Container } from '@amzn/awsui-components-core';
import { CollectionAudience, Owner } from '@amzn/awscat-pattern-library-service-model';

import constants from '../../common/constants';
import EditCollectionOwners from './EditCollectionOwners';

interface Props {
  collectionId: string;
  owners: Owner[];
  setOwners: (owners: Owner[]) => void;
  audience: CollectionAudience;
  setAudience: (audience: CollectionAudience) => void;
}

function EditCollectionPermissionsTab({
  owners,
  setOwners,
  audience,
  setAudience,
  collectionId,
}: Props) {
  // @ts-expect-error TS7031 - strict migration
  const handleAudienceChange = ({ detail }) => {
    setAudience(detail.value);
  };

  return (
    <SpaceBetween size="m">
      <EditCollectionOwners collectionId={collectionId} owners={owners} setOwners={setOwners} />
      <Container header={<Header variant="h3">Visibility</Header>}>
        <div className="create-collection-permission-container">
          <Tiles
            onChange={handleAudienceChange}
            value={audience}
            items={[
              {
                label: constants.MY_COLLECTION_AUDIENCE_LABEL_ONLY_OWNER,
                value: CollectionAudience.PRIVATE,
              },
              {
                label: constants.MY_COLLECTION_AUDIENCE_LABEL_INTERNAL,
                value: CollectionAudience.INTERNAL,
              },
            ]}
            ariaRequired
          />
        </div>
      </Container>
    </SpaceBetween>
  );
}

export default EditCollectionPermissionsTab;
